import InvoiceManagementProvider from "./InvoiceManagementProvider";
import InvoiceOutboundManagementOverview from "./InvoiceOutboundManagementOverview";

function InvoiceOutboundManagement(props) {
    return (
        <InvoiceManagementProvider>
            <InvoiceOutboundManagementOverview />
        </InvoiceManagementProvider>
    );
}

export default InvoiceOutboundManagement;
